import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import VerificationInput from 'react-verification-input';
import Countdown from 'react-countdown';
import { adminLogin, adminEnviarCodigo2FA } from '../../store/actions';
import { Regex, Validate, RegexExtra, Config } from '../../other';
import { Grid, withStyles } from '@material-ui/core';
import {
  PublicLayout,
  InputUI,
  ButtonUI,
  AlertUI,
  CardModuleUI,
} from '../common';
import { createAmplitudeEventWithDevice, amplitude_events } from '../amplitude';
import amplitude from 'amplitude-js';

const CountdownLabel = ({ minutes, seconds, idCountry, classes }) => {
  if (minutes === 0 && seconds === 0) {
    return (
      <p className={classes.text_resend_2fa}>
        <a
          href={idCountry === 'COL' ? '/login?idCountry=COL' : '/login'}
          className={classes.link}
        >
          Reenviar código
        </a>
      </p>
    );
  } else {
    return (
      <p className={classes.text_countdown_2fa}>
        Reenviar código en {minutes}:{seconds < 10 ? '0' + seconds : seconds}
      </p>
    );
  }
};

class Login_ extends Component {
  recaptchaRef = React.createRef();

  state = {
    step: 0,
    timer_count: null,
    login: {
      t_email: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'email',
        label: 'Email',
        id: 't_email',
        name: 't_email',
        change_param: 'login',
        regex: Regex.EMAIL,
        value: '',
        default_value: '',
        placeholder: 'algo@algo.com',
        messages: {
          error: 'Por favor, ingrese un email válido',
          error_extra: RegexExtra.EMAIL,
        },
      },
      t_clave: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'password',
        label: 'Clave',
        id: 't_clave',
        name: 't_clave',
        change_param: 'login',
        regex: Regex.CLAVE,
        value: '',
        default_value: '',
        placeholder: '******',
        messages: {
          error: 'Por favor, ingrese una clave válida',
          error_extra: RegexExtra.CLAVE,
        },
      },
    },
    login_2fa: {
      t_codigo: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'text',
        label: '2FA',
        id: 't_codigo',
        name: 't_codigo',
        change_param: 'login_2fa',
        regex: Regex.SIX_DIGIT,
        value: '',
        default_value: '',
        placeholder: '',
        messages: {
          error: 'Código incorrecto',
          error_extra: RegexExtra.SIX_DIGIT,
        },
      },
    },
    forms: {
      login: false,
      login_2fa: false,
    },
    recaptcha_state: false,
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
  };

  initCounter = () => Date.now() + 600000;

  handleChange = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(
      {
        [aditional]: {
          ...this.state[aditional],
          [name]: {
            ...this.state[aditional][name],
            value: value,
          },
        },
      },
      () => {
        Validate.validate_input(this.state[aditional][name], blur, (input) => {
          this.setState({
            [aditional]: {
              ...this.state[aditional],
              [name]: input,
            },
          });
        });
      }
    );
  };

  handleChange2FAInput = (value) => {
    this.setState(
      {
        login_2fa: {
          ...this.state.login_2fa,
          t_codigo: {
            ...this.state.login_2fa.t_codigo,
            value: value,
          },
        },
      },
      () => {
        Validate.validate_input(
          this.state.login_2fa.t_codigo,
          true,
          (input) => {
            this.setState({
              login_2fa: {
                ...this.state.login_2fa,
                t_codigo: input,
              },
            });
          }
        );
      }
    );
  };

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  handleSubmit = (t_captcha) => {
    this.setState(
      {
        forms: {
          ...this.state.forms,
          login_2fa: true,
        },
        recaptcha_state: false,
      },
      () => {
        if (t_captcha) {
          let form = this.state.login;
          let form_2fa = this.state.login_2fa;

          if (form_2fa.t_codigo.auth) {
            this.props.adminLogin(
              {
                t_email: form.t_email.value,
                t_clave: form.t_clave.value,
                t_codigo: form_2fa.t_codigo.value,
                t_captcha: t_captcha,
              },
              (err, resp) => {
                if (err) {
                  this.setState(
                    {
                      forms: {
                        ...this.state.forms,
                        login_2fa: false,
                      },
                      alert: {
                        ...this.state.alert,
                        open: true,
                        message: resp.message,
                      },
                    },
                    () => {
                      createAmplitudeEventWithDevice(
                        amplitude_events.signin_failed.event_name,
                        amplitude_events.signin_failed.event_params
                      );
                      this.resetRecaptcha();
                    }
                  );
                } else {
                  createAmplitudeEventWithDevice(
                    amplitude_events.signin_successful.event_name,
                    amplitude_events.signin_successful.event_params
                  );
                }
              }
            );
          } else {
            this.setState(
              {
                forms: {
                  ...this.state.forms,
                  login_2fa: false,
                },
                alert: {
                  open: true,
                  type: 'error',
                  message: 'Ingrese un código de verificación correcto',
                },
              },
              () => {
                createAmplitudeEventWithDevice(
                  amplitude_events.signin_failed.event_name,
                  amplitude_events.signin_failed.event_params
                );
                this.resetRecaptcha();
              }
            );
          }
        } else {
          this.setState(
            {
              forms: {
                ...this.state.forms,
                login_2fa: false,
              },
              alert: {
                open: true,
                type: 'error',
                message:
                  'Ha ocurrido un error con el captcha, intente nuevamente',
              },
            },
            () => {
              createAmplitudeEventWithDevice(
                amplitude_events.signin_failed.event_name,
                amplitude_events.signin_failed.event_params
              );
              this.resetRecaptcha();
            }
          );
        }
      }
    );
  };

  handleSubmitObtenerCodigo2FA = (t_captcha) => {
    this.setState(
      {
        forms: {
          ...this.state.forms,
          login: true,
        },
        recaptcha_state: false,
      },
      () => {
        if (t_captcha) {
          let form = this.state.login;

          if (Validate.validar_formulario(form)) {
            this.props.adminEnviarCodigo2FA(
              {
                t_email: form.t_email.value,
                t_clave: form.t_clave.value,
                t_captcha: t_captcha,
              },
              (err, resp) => {
                if (err) {
                  let codigo_existente =
                    resp.message ===
                    'Ya posees un código de ingreso, revisa tu bandeja de email o spam';
                  this.setState(
                    {
                      forms: {
                        ...this.state.forms,
                        login: false,
                      },
                      alert: {
                        ...this.state.alert,
                        open: true,
                        message: resp.message,
                      },
                      step: codigo_existente ? 1 : 0,
                      timer_count: this.initCounter(),
                    },
                    () => {
                      this.resetRecaptcha();
                    }
                  );
                } else {
                  let login = resp.login;
                  if (login) {
                    createAmplitudeEventWithDevice(
                      amplitude_events.signin_successful.event_name,
                      amplitude_events.signin_successful.event_params
                    );
                  } else {
                    this.setState(
                      {
                        forms: {
                          ...this.state.forms,
                          login: false,
                        },
                        step: 1,
                        timer_count: this.initCounter(),
                      },
                      () => {
                        this.resetRecaptcha();
                      }
                    );
                  }
                }
              }
            );
          } else {
            Validate.validar_formulario_actualizar_obj(form, (new_form) => {
              this.setState(
                {
                  forms: {
                    ...this.state.forms,
                    login: false,
                  },
                  login: new_form,
                },
                () => {
                  this.resetRecaptcha();
                }
              );
            });
          }
        } else {
          this.setState(
            {
              forms: {
                ...this.state.forms,
                login: false,
              },
              alert: {
                open: true,
                type: 'error',
                message:
                  'Ha ocurrido un error con el captcha, intente nuevamente',
              },
            },
            () => {
              this.resetRecaptcha();
            }
          );
        }
      }
    );
  };

  fireCaptcha = (e) => {
    e.preventDefault();
    this.setState(
      {
        recaptcha_state: true,
      },
      () => this.recaptchaRef.current.execute()
    );
  };

  resetRecaptcha = () => {
    this.setState(
      {
        recaptcha_state: false,
      },
      () => this.recaptchaRef.current.reset()
    );
  };

  render() {
    let { classes, idCountry } = this.props;
    amplitude.getInstance().setUserId(0);

    if (this.state.step === 0) {
      //login
      return (
        <PublicLayout>
          <AlertUI
            open={this.state.alert.open}
            message={this.state.alert.message}
            type={this.state.alert.type}
            handleCloseAlert={this.handleCloseAlert}
          />
          <form onSubmit={this.fireCaptcha}>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <CardModuleUI big_shadow>
                  <div className={classes.card_padding}>
                    <div className={classes.logo_wrapper}>
                      <Link
                        to={
                          idCountry === 'COL'
                            ? '/login?idCountry=COL'
                            : '/login'
                        }
                      >
                        <img
                          src="https://dk0k1i3js6c49.cloudfront.net/landingpage/images/v4/empretienda-green-logo.png"
                          alt="Empretienda logo"
                          className={classes.logo}
                        />
                      </Link>
                    </div>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.login.t_email}
                    />
                    <div className={classes.separator}></div>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.login.t_clave}
                    />
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      size="invisible"
                      sitekey={Config.RECAPTCHA_PUBLIC_KEY}
                      onChange={(token) =>
                        this.handleSubmitObtenerCodigo2FA(token)
                      }
                      onExpired={() => this.resetRecaptcha()}
                      onErrored={() => this.resetRecaptcha()}
                    />
                    <div className={classes.separator}></div>
                    <div className={classes.separator}></div>
                    <ButtonUI
                      type="submit"
                      label="Ingresar"
                      size="large"
                      border_radius
                      fullWidth={false}
                      isLoading={this.state.forms.login}
                      disabled={this.state.recaptcha_state}
                    />
                  </div>
                </CardModuleUI>
              </Grid>
              <Grid item xs={12}>
                <p className={classes.link_left}>
                  ¿Olvidaste la contraseña?{' '}
                  <Link
                    to={
                      idCountry === 'COL'
                        ? '/recuperar-clave?idCountry=COL'
                        : '/recuperar-clave'
                    }
                    className={classes.link}
                  >
                    Recuperar
                  </Link>
                </p>
                <p className={classes.link_below_left}>
                  ¿Todavía no tenes tienda?{' '}
                  <Link
                    to={
                      idCountry === 'COL'
                        ? '/crear-tienda?idCountry=COL'
                        : '/crear-tienda'
                    }
                    className={classes.link}
                  >
                    Crear
                  </Link>
                </p>
                <div className={classes.separator_mobile}></div>
              </Grid>
            </Grid>
          </form>
        </PublicLayout>
      );
    } else {
      //2fa
      return (
        <PublicLayout>
          <AlertUI
            open={this.state.alert.open}
            message={this.state.alert.message}
            type={this.state.alert.type}
            handleCloseAlert={this.handleCloseAlert}
          />
          <form onSubmit={this.fireCaptcha}>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <CardModuleUI big_shadow>
                  <div className={classes.card_padding}>
                    <p className={classes.title_2fa}>Verificación de ingreso</p>
                    <p className={classes.subtitle_2fa}>
                      Ingresar el código que te enviamos por email:
                    </p>
                    <p className={classes.text_email_2fa}>
                      {this.state.login.t_email.value}
                    </p>
                    <VerificationInput
                      validChars="0-9"
                      placeholder=""
                      length={6}
                      autoFocus
                      onChange={this.handleChange2FAInput}
                      onComplete={this.handleChange2FAInput}
                      classNames={{
                        character: classes.character_2fa,
                        characterSelected: classes.character_selected_2fa,
                      }}
                    />
                    <Countdown
                      date={this.state.timer_count}
                      renderer={({ minutes, seconds }) => (
                        <CountdownLabel
                          minutes={minutes}
                          seconds={seconds}
                          classes={classes}
                          idCountry={idCountry}
                        />
                      )}
                    />
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      size="invisible"
                      sitekey={Config.RECAPTCHA_PUBLIC_KEY}
                      onChange={(token) => this.handleSubmit(token)}
                      onExpired={() => this.resetRecaptcha()}
                      onErrored={() => this.resetRecaptcha()}
                    />
                    <div className={classes.separator}></div>
                    <ButtonUI
                      type="submit"
                      label="Verificar"
                      size="large"
                      border_radius
                      fullWidth={false}
                      isLoading={this.state.forms.login_2fa}
                      disabled={
                        this.state.recaptcha_state ||
                        !this.state.login_2fa.t_codigo.auth
                      }
                    />
                  </div>
                </CardModuleUI>
              </Grid>
              <Grid item xs={12}>
                <p className={classes.link_left}>
                  <a
                    href={
                      idCountry === 'COL' ? '/login?idCountry=COL' : '/login'
                    }
                    className={classes.link}
                  >
                    Iniciar sesión en una cuenta diferente
                  </a>
                </p>
                <div className={classes.separator_mobile}></div>
              </Grid>
            </Grid>
          </form>
        </PublicLayout>
      );
    }
  }
}

const styles = (theme) => ({
  separator: {
    width: '100%',
    height: '15px',
  },
  separator_mobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '50px',
    },
  },
  link_left: {
    color: '#666',
    fontFamily: 'Roboto',
    lineHeight: '1',
    textAlign: 'center',
    fontSize: '0.9rem',
    marginTop: '5px',
    marginBottom: '20px',
    padding: '0',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0px',
      textAlign: 'left',
    },
  },
  link_below_left: {
    color: '#666',
    fontFamily: 'Roboto',
    lineHeight: '1',
    textAlign: 'center',
    fontSize: '0.9rem',
    marginTop: '10px',
    marginBottom: '20px',
    padding: '0',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0px',
      textAlign: 'left',
    },
  },
  title_2fa: {
    color: '#383838',
    lineHeight: '32px',
    textAlign: 'left',
    fontWeight: '500',
    fontSize: '28px',
    marginBottom: '20px',
    padding: '0',
  },
  subtitle_2fa: {
    color: '#383838',
    lineHeight: '26px',
    textAlign: 'left',
    fontWeight: '400',
    fontSize: '18px',
    marginBottom: '20px',
    padding: '0',
  },
  text_email_2fa: {
    color: '#383838',
    lineHeight: '16px',
    textAlign: 'left',
    fontWeight: '700',
    fontSize: '14px',
    marginBottom: '20px',
    padding: '0',
  },
  text_countdown_2fa: {
    color: '#A5A5A5',
    lineHeight: '16px',
    textAlign: 'left',
    fontWeight: '400',
    fontSize: '14px',
    marginTop: '20px',
    padding: '0',
  },
  text_resend_2fa: {
    color: theme.palette.primary.main,
    lineHeight: '16px',
    textAlign: 'left',
    fontWeight: '400',
    fontSize: '14px',
    marginTop: '20px',
    padding: '0',
  },
  character_2fa: {
    backgroundColor: '#fff',
    borderRadius: '6px',
    border: '1px solid #383838',
    fontSize: '36px',
    fontWeight: '400',
    color: '#383838',
  },
  character_selected_2fa: {
    backgroundColor: '#fff',
    borderRadius: '6px',
    border: '1px solid #53B755',
    outline: '2px solid #53B755',
    fontSize: '36px',
    fontWeight: '400',
    color: '#383838',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  card_padding: {
    padding: '10px',
    [theme.breakpoints.up('sm')]: {
      padding: '10px 30px',
    },
  },
  logo_wrapper: {
    marginBottom: '30px',
  },
  logo: {
    width: '250px',
    maxWidth: '100%',
  },
});

const mapStateToProps = () => {
  const searchParams = new URLSearchParams(document.location.search);
  return {
    idCountry: searchParams.get('idCountry'),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    adminLogin: (usuario, callback) => dispatch(adminLogin(usuario, callback)),
    adminEnviarCodigo2FA: (usuario, callback) =>
      dispatch(adminEnviarCodigo2FA(usuario, callback)),
  };
};

export const Login = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Login_)
);
